import { useQuery } from '@tanstack/react-query';

import { getEOI } from '~/services/AgentHub/AgentService';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useGetEoi(id: string | undefined) {
  return useQuery({
    queryKey: ['eoi', id],
    queryFn: async () => {
      return await getEOI(id);
    },
    enabled: !!id,
    staleTime: FIVE_MINUTES,
  });
}
